import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHome, 
  faSearch, 
  faHeart, 
  faUser 
} from '@fortawesome/free-solid-svg-icons';
import '../StylesComponents/mobile-nav-bar.css';

function MobileNavBar({ toggleWishlist, setMenuOpen }) {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  
  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const controlNavbar = () => {
      if (typeof window !== 'undefined') {
        const currentScrollY = window.scrollY;
        
        // Always show at the very top
        if (currentScrollY < 10) {
          setIsVisible(true);
        } 
        // Hide on scroll down, show on scroll up
        else if (currentScrollY > lastScrollY && currentScrollY > 100) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
        
        setLastScrollY(currentScrollY);
      }
    };

    window.addEventListener('scroll', controlNavbar);
    return () => {
      window.removeEventListener('scroll', controlNavbar);
    };
  }, [lastScrollY]);

  const handleSearchClick = (e) => {
    e.preventDefault();
    setMenuOpen(true);
    setTimeout(() => {
      const searchInput = document.querySelector('.search-input');
      if (searchInput) searchInput.focus();
    }, 300);
  };

  return (
    <nav className={`mobile-nav-bar ${!isVisible ? 'hidden' : ''}`}>
      <Link to="/" className={`mobile-nav-item ${isActive('/') ? 'active' : ''}`}>
        <FontAwesomeIcon icon={faHome} />
        <span>Home</span>
      </Link>
      
      <a href="#search" className="mobile-nav-item" onClick={handleSearchClick}>
        <FontAwesomeIcon icon={faSearch} />
        <span>Search</span>
      </a>
      
      <button className="mobile-nav-item" onClick={toggleWishlist}>
        <FontAwesomeIcon icon={faHeart} />
        <span>Watchlist</span>
      </button>
      
      <Link 
        to="/profile" 
        className={`mobile-nav-item ${isActive('/profile') ? 'active' : ''}`}
      >
        <FontAwesomeIcon icon={faUser} />
        <span>Profile</span>
      </Link>
    </nav>
  );
}

export default MobileNavBar;
